import{ memo } from "react";
import HomeContent from "./homeContent";
const HomePage = () =>{
    return (
      <HomeContent />
    );
}

export default memo(HomePage);